module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_19.75df776b.png";